"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formTempNameInfoApi = formTempNameInfoApi;
exports.getFormConfigInfo = getFormConfigInfo;
exports.knowUserCaptchaApi = knowUserCaptchaApi;
exports.knowUserSmsCaptchaApi = knowUserSmsCaptchaApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function getFormConfigInfo(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/merchant/form/temp/info',
    method: 'GET',
    params: data
  });
}

/**
 * 通过名称查询详情
 * @param pram
 */
function formTempNameInfoApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/form/temp/name/info",
    method: 'get',
    params: params
  });
}

/**
 * @description 验证行为验证码
 */
function knowUserSmsCaptchaApi(data) {
  return (0, _request.default)({
    url: '/publicly/safety/check',
    method: 'post',
    data: data
  });
}

/**
 * @description 获取行为验证码
 */
function knowUserCaptchaApi(data) {
  return (0, _request.default)({
    url: '/publicly/safety/get',
    method: 'post',
    data: data
  });
}